import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HR_Documento } from '../../../models/HR_Documento';
import { Personal } from '../../../models/personal';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { Observable } from 'rxjs/Observable';
import { modalComponent } from '../../../utils/modal/modal.component';
import { MatDialog } from '@angular/material';
import { utils } from '../../../utils/utils';

@Component({
  selector: 'my-documento-addedit',
  styles: [],
  templateUrl: './documentoAddEdit.component.html',
  providers: [generalService]
})

export class documentoAddEditComponent implements OnInit {
  public documento: HR_Documento;
  titulo = "Agregar";
  public tipoDoc:Array<any>;
  tipoDocFiltradas: any;
  public _utils:utils;
  public personal:Personal;
  urlValidate:string;
  public PERSON_ID:any;
  public test:any;

  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService) { 
    this.documento = new HR_Documento();
    this.personal = new Personal();
    this.dataService.guardado=false;
    this._utils = new utils();
  }
  
  ngOnInit() {
      this.getTipoDoc();
      this.documento.ORIGINALCOPIA = "Original";
      this.PERSON_ID = this.dataService.idPersonal;
      this.getInit(this.PERSON_ID);
      if(this.dataService.tipo == "editar"){
        this.titulo = "Editar";
        this.documento.DOCUMENT_iD = this.dataService.id;
        this.buscarDocumento();
      }
      this.dataService.mensajeAlert = "";
  }

  getInit(id:any){
      this._generalService.metodoCall(`misc/getNamePerson/${id}`).subscribe(
          result => {            
            let res = JSON.parse(result);
            
            this.personal.NAME = res[0].NAME;
            this.personal.LAST_NAME = res[0].LAST_NAME;
            this.personal.MOTHER_LAST_NAME = res[0].MOTHER_LAST_NAME;
            },
          error => {
            console.log(<any>error);
          }
        );
    }


  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  buscarDocumento(){
      this._generalService.metodoCall("documento/consultarDocumento/"+this.documento.DOCUMENT_iD).subscribe(
        result => {
          if(result == "[]")
          {
              this.dataService.mensajeAlert = "El documento seleccionado ya no se encuentra disponible";
              this.cerrarModal();
          }
          else{
            this.documento = JSON.parse(result.replace("[", "").replace("]", ""));
            this.urlValidate = this.documento.urlimagen;
            this.documento.anterior = this.documento.TIPODOCUMENTO;
          }
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  onKeyUp(event: any): void {
    this.tipoDocFiltradas = this.tipoDocFilter(event.target.value);
  }

  tipoDocFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.tipoDoc.filter(s => new RegExp(`^${val}`, 'gi').test(s.NAME));
    } else {
      arr = this.tipoDoc;
    }
    return Observable.of(arr);
  }

  getTipoDoc(){
      this._generalService.metodoCall("misc/consultarLookup/DOCUMENT TYPE").subscribe(
        result => {
          this.tipoDoc = JSON.parse(result);
          this.tipoDocFiltradas = this.tipoDocFilter('');                          
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  onSubmit() {
    let validacion = false;
    if(this.dataService.tipo == "editar"){
      if(this.documento.urlimagen == this.urlValidate)
      {
          validacion = true;
      }
    }

    if(!validacion){
      if(this.documento.BASE64){
        validacion = true;
      }
    }

    if(validacion){

        let tipo = "agregar";
        let metodo = "documento/insertarDocumento/";
        if(this.dataService.tipo == "editar"){
          metodo = "documento/actualizarDocumento/"+this.documento.DOCUMENT_iD;
          tipo = "editar";
        }

        if(this.documento.ORIGINALCOPIA == "Original"){
          this.documento.ORIGINAL_FLAG = "Y";
          this.documento.COPY_FLAG = "F";
        }
        else{
          this.documento.ORIGINAL_FLAG = "F";
          this.documento.COPY_FLAG = "Y";
        }

        this.documento.PERSON_ID = this.PERSON_ID;
        this.documento.DOCUMENT_TYPE = this.documento.TIPODOCUMENTO;
               
        this._generalService.metodoCallParamsPutPost(tipo, this.documento, metodo).subscribe(
            result => {
              if(result == "El tipo de documento seleccionado ya se encuentra registrado")
              {
                this.modal("alert", result);
              }
              else
              {
                if(result != "")
                {
                  this.dataService.mensajeAlert = result;
                }
                else{
                  this.dataService.guardado=true;
                }
                this.cerrarModal();
              }
            },
            error => {
              var errorMsj = <any>error;
              console.log(errorMsj);
            }
        );

        

      }
      else{
      this.modal("alert", "Seleccione un archivo");
    }
  }



  getFileName(e){
    let f = e.target.files[0];
    let re = /(?:\.([^.]+))?$/;
    if (f != undefined) {
        let ext = re.exec(f.name)[1];
        if (ext) {
            //if (ext.toString().toLowerCase() != "png" && ext.toString().toLowerCase() != "jpg" && ext.toString().toLowerCase() != "jpeg") {
            //    this.modal("alert", 'La extensión del archivo no coincide con el tipo de configuración seleccionada');
            //}
            //else{
              let _size = f.size;
              let fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
              i = 0; while (_size > 900) { _size /= 1024; i++; }
              let exactSize = (Math.round(_size * 100) / 100);

                  if (fSExt[i] != "GB") {
                      if (exactSize > 5 && fSExt[i] == "MB") {
                          this.modal("alert", 'El archivo supera el tamaño máximo de 5 mb');
                      }
                      else{
                        this.documento.urlimagen = e.target.value.split('\\').pop().split('/').pop();
                        this.documento.FILE_NAME = e.target.value.split('\\').pop().split('/').pop();
                        //this.documento.DOCUMENTO = f;
                        this.getBase64(f);
                      }
                  }
                  else{
                    this.modal("alert", 'El archivo supera el tamaño máximo de 5 mb');
                  }                  
            //}
        }
        else {
            this.modal("alert", 'El archivo no cuenta con extensión');
        }
    }

         
  }

  getBase64(file) {
   var reader = new FileReader();
   reader.readAsDataURL(file);
   let that = this;
   reader.onload = function () {
     that.documento.BASE64 = reader.result as string;
   };
   reader.onerror = function (error) {
     console.log('Error: ', error);
   };
}

  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }
}



// WEBPACK FOOTER //
// ./src/app/personal/documentos/agregar-editar/documentoAddEdit.component.ts